<template>
  <main id="feedback">
    <div
      v-if="$page.props.auth.user.is_impersonating"
      class="notification is-warning"
      id="impersonate-warning"
    >
      You are impersonating a user
      <a
        class="button is-button is-danger ml-3"
        :href="route('stopImpersonateUser')"
        >Stop Impersonation</a
      >
    </div>

    <header class="header center">
      <div class="logo"><img src="/assets/logo.png" alt="" /></div>
      <div class="tenant-info">
        <p>Greenbank</p>
      </div>
    </header>
    <b-navbar centered type="is-dark">
      <template slot="start">
        <b-navbar-item :href="route('feedback.home')"> Home </b-navbar-item>
        <b-navbar-item :href="route('feedback.account')">
          Settings / Reset Password
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item>
          <inertia-link :href="this.route('logout')" method="post">
            <b-icon pack="fas" icon="sign-out-alt" size="is-small"></b-icon>
            Logout
          </inertia-link>
        </b-navbar-item>
      </template>
    </b-navbar>
    <div class="body section">
      <b-message v-if="$page.props.flash.success" type="is-success">
        {{ $page.props.flash.success }}
      </b-message>
      <slot />
    </div>
  </main>
</template>

<script>
export default {};
</script>
